(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name flightPunctuality.service:FlightPunctualityService
     *
     * @description
     *
     */
    angular
    	.module('flightPunctuality')
        .service('FlightPunctualityService', FlightPunctualityService);

    function FlightPunctualityService(RemoteService, FlightPunctualityRequestFactory) {
    	var self = this;

    	self.getDepartureFlightData = function(searchParam, successFn, errorFn){
    		var searchReq = FlightPunctualityRequestFactory.getSearchRequest(searchParam);
    		RemoteService.searchDepartureFlightData(searchReq).then(
				function (response) {
					if(response.success){
						angular.forEach(response.flightPunctualityDTOSDeparture, function(flight){
							flight.className = 'departureFlights';
						});
						successFn(response);
					}
				}, function(error) {
					errorFn(error.msg[0]);
				});
    	};

    	self.getArrivalFlightData = function(searchParam, successFn, errorFn){
    		var searchReq = FlightPunctualityRequestFactory.getSearchRequest(searchParam);
    		RemoteService.searchArrivalFlightData(searchReq).then(
				function (response) {
					if(response.success ){
						angular.forEach(response.flightPunctualityDTOSArrival, function(flight){
							flight.className = 'arrivalFlights';
						});
						successFn(response);
					}
				}, function(error) {
					errorFn(error.msg[0]);
				});
    	};

    	self.getIntermediateFlightData = function(searchParam, successFn, errorFn){
    		var searchReq = FlightPunctualityRequestFactory.getSearchRequest(searchParam);
    		RemoteService.searchIntermediateFlightData(searchReq).then(
				function (response) {
					if(response.success){
						angular.forEach(response.flightPunctualityDTOSIntermediate, function(flight){
							flight.className = 'intermediateFlights';
						});
						successFn(response);
					}
				}, function(error) {
					errorFn(error.msg[0]);
				});
    	};

    	self.getJoininigCrews = function(flightLegId, successFn, errorFn){
    		RemoteService.searchJoiningCrewsForFlight(flightLegId).then(
    			function(response) {
    				if(response.success) {
    					successFn(response);
    				}
    			}, function(error) {
    				errorFn(error.msg[0]);
    			});
    	};

    	self.getFlightLogDetails = function(flightLegId, successFn, errorFn){
    		RemoteService.getFlightLogDetails(flightLegId).then(
    			function(response) {
    				if(response.success) {
    					successFn(response);
    				}
    			}, function(error) {
    				errorFn(error.msg[0]);
    			});
    	};

    	self.getDelayCodes = function(successFn, errorFn){
    		RemoteService.getDelayCodes().then(
    			function(response) {
    				if(response.success){
    					successFn(response.delayCodeAdaptDTOs);
    				}
    			}, function(error) {
					errorFn(error.msg[0]);
				});
    	};

      self.sendLIDOWABMessage = function(flightLegId, successFn, errorFn){
        RemoteService.sendLIDOWABMessage(flightLegId).then(
          function(response) {
            if(response.success) {
              successFn("Successfully sent LIDO");
            }
          }, function(error) {
            errorFn(error.msg[0]);
          });
      };

    	self.getDutyInformation = function(departureFlight){
    		//flightNumber (aircraftRegistrationNumber) - route DEPARTURE :
    		//estimatedDepartureDate - estimatedDepartureTime ARRIVAL : estimatedArrivalDate - estimatedArrivalTime
    		//GATE : bayGate
    		return departureFlight.SAI +"("+departureFlight.REG+") - "+ departureFlight.ROUTE +
    		" DEPARTURE : " + departureFlight.DATE + " - " +departureFlight. RSTD +
    		" ARRIVAL : " + departureFlight.DATE + " - " +departureFlight. RSTA+
    		" GATE : ";

    	}

    	self.appendToGridFlightList = function (existingFlights, newFlights, tab) {
    		var existingGenericFlights = [], newGenericFlights = [];
    		if(tab == 1) {
    			existingGenericFlights = existingFlights.flightPunctualityDTOSDeparture;
    			newGenericFlights = newFlights.flightPunctualityDTOSDeparture;
    		} else if(tab == 2) {
    			existingGenericFlights = existingFlights.flightPunctualityDTOSArrival;
    			newGenericFlights = newFlights.flightPunctualityDTOSArrival;
    		} else {
    			existingGenericFlights = existingFlights.flightPunctualityDTOSIntermediate;
    			newGenericFlights = newFlights.flightPunctualityDTOSIntermediate;
    		}
			angular.forEach(newGenericFlights, function (flightObj) {
				var foundIndex = _.findIndex(existingGenericFlights, {flightLegId: flightObj.flightLegId})
				if (foundIndex >= 0) {
					existingGenericFlights.splice(foundIndex, 1, flightObj);
				} else {
					existingGenericFlights.push(flightObj);
				}
			});
		};

    }
})();
